var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeySilver = function SvgKeySilver(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#858585"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.353 13.506a1.243 1.243 0 0 0 0 1.736c.47.478 1.234.478 1.708 0l.262-.266.959.974c.394.4 1.035.4 1.43 0a1.04 1.04 0 0 0 0-1.452l-.96-.974.802-.814.959.973c.394.4 1.036.4 1.43 0a1.04 1.04 0 0 0 0-1.451l-.96-.974 1.228-1.247c.383.167.805.255 1.248.255 1.771 0 3.208-1.459 3.208-3.258S15.23 3.75 13.459 3.75c-1.771 0-3.207 1.459-3.207 3.258 0 .45.09.878.25 1.268l-5.149 5.23Zm8.106-8.056c-.847 0-1.534.697-1.534 1.558 0 .86.687 1.558 1.534 1.558s1.534-.697 1.534-1.558c0-.86-.687-1.558-1.534-1.558Z",
    fill: "#fff"
  })));
};
export default SvgKeySilver;